/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetNotificationsResult } from '../../models/get-notifications-result';

export interface GetNotifications$Params {
  PageIndex?: number;
  PageSize?: number;
}

export function getNotifications(
  http: HttpClient,
  rootUrl: string,
  params?: GetNotifications$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetNotificationsResult>> {
  const rb = new RequestBuilder(rootUrl, getNotifications.PATH, 'get');
  if (params) {
    rb.query('PageIndex', params.PageIndex, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetNotificationsResult>;
    }),
  );
}

getNotifications.PATH = '/Notifications';
